import React from "react";
import PageLayout from "./PageLayout";
import DiagnosticSection from "./DiagnosticSection";
import usePageMeta from "../hooks/usePageMeta";

const DiagnosticPage = () => {
  usePageMeta({
    title: "Diagnóstico interactivo | RG Servicio Técnico",
    description:
      "Realizá un diagnóstico paso a paso para identificar problemas de PC, notebooks y equipos. Recomendaciones técnicas en español.",
    canonical: "https://rgserviciotecnico.com/diagnostico"
  });

  return (
    <PageLayout className="bg-background">
      <DiagnosticSection headingLevel="h1" showBackButton />
    </PageLayout>
  );
};

export default DiagnosticPage;
